import { IPageInfo } from '@umu/umu-types';
import { IDepartmentSearchRes } from '../../interface';


const defaultPageInfo: IPageInfo = {
    current_page: 1,
    list_total_num: 0,
    total_num: 0,
    size: 20,
    total_page_num: 1,
};
const defaultDepartmentData: IDepartmentSearchRes = {
    path: [],
    list: [],
    page_info: defaultPageInfo
};
export { defaultPageInfo, defaultDepartmentData };
